<template>
 <div>
       <el-row>
        <el-col :span="6" :offset="9">
            <el-card class="box-card">
              <el-form >
                <el-form-item label="Username" >
                    <el-input type="input" v-model="username"></el-input>
                </el-form-item>
                <el-form-item label="Password">
                  <el-input type="password" v-model="password"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="login()">Login</el-button>
                </el-form-item>
            </el-form>
            </el-card>
        </el-col>
    </el-row>
 </div>
</template>

<script>
import {authenticate} from "@/api/auth.api";
import {httpClient} from "@/api/httpClient";

export default {
    name: "LoginPage",
    data: () => ({
      username: '',
      password: '',
    }),
    methods: {
      async login() {
        let payload = {
          "username": this.username,
          "password": this.password
        }
        const response = await authenticate(payload);
        if (response.status == 200) {
          const token = response.data.token
          localStorage.setItem('user-token', token) // store the token in localstorage
          httpClient.defaults.headers.common['Authorization'] = "Token " + token
          await this.$router.push('/')
        } else {
          delete httpClient.defaults.headers.common['Authorization']
          localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
        }
      }
    }
}


</script>

<style scoped>

</style>